import { render, staticRenderFns } from "./TypeFilter.vue?vue&type=template&id=b779ed52&scoped=true&"
import script from "./TypeFilter.vue?vue&type=script&lang=js&"
export * from "./TypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b779ed52",
  null
  
)

export default component.exports